const pageNameKey = "otaUpdateSummary";

export const otaUpdateSummaryEn = {
  [pageNameKey]: {
    latestText: "LATEST",
    versionText: "Version",
    sizeText: "Size",
    digestText: "Digest",
    uploadTimeText: "Upload Time",
    uploaderAltText: "Uploader",
    checkboxText: "Create Backup before installation",
    installText: "Install",
    downloadText: "Download",
    failedMsg: "Failed to start installation",
    errorMsg: "Something went wrong while starting installation.",
    noBackupsText: "No backups available",
    noFirmwareText: "No firmware available",
    noConfigurationText: "No configuration available",
    backupInfoText: "The card shows you the latest backup created.",
    firmwareInfoText: "The card shows you the latest firmware uploaded.",
    configurationInfoText:
      "The card shows you the latest configuration uploaded.",
    pushFirmwareText: "Push Firmware",
    pushBackupText: "Push Backup",
    firmwareAlreadyInstalledTooltip:
      "This firmware version {version} is already installed on the machine.",
    backupAlreadyInstalledTooltip:
      "This backup version {version} is already installed on the machine.",
    firmwareInstallationInProgressTooltip:
      "Firmware update in progress. Version {version} is currently being transferred and installed.",
    backupInstallationInProgressTooltip:
      "Backup update in progress. Version {version} is currently being transferred and installed.",
    installationFailedCloseErrorFirmwareTooltip:
      "Close the error message above to push the firmware again.",
    installationFailedCloseErrorBackupTooltip:
      "Close the error message above to push the backup again.",
  },
};

export const otaUpdateSummaryPtBr = {
  [pageNameKey]: {
    latestText: "Mais recente",
    versionText: "Versão",
    sizeText: "Tamanho",
    digestText: "Hash",
    uploadTimeText: "Hora do upload",
    uploaderAltText: "Enviador",
    checkboxText: "Crie um backup antes da instalação",
    installText: "Instalar",
    downloadText: "Baixar",
    failedMsg: "Falha ao iniciar a instalação",
    errorMsg: "Algo deu errado ao iniciar a instalação.",
    noBackupsText: "Nenhum backup disponível",
    noFirmwareText: "Nenhum firmware disponível",
    noConfigurationText: "Nenhuma configuração disponível",
    backupInfoText: "O cartão mostra o backup mais recente criado.",
    firmwareInfoText:
      "O card mostra para você o firmware mais recente enviado.",
    configurationInfoText: "O card mostra a configuração mais recente enviada.",
    pushFirmwareText: "Enviar Firmware",
    pushBackupText: "Enviar Backup",
    firmwareAlreadyInstalledTooltip:
      "Esta versão de firmware {version} já está instalada na máquina.",
    backupAlreadyInstalledTooltip:
      "Esta versão de backup {version} já está instalada na máquina.",
    firmwareInstallationInProgressTooltip:
      "Atualização de firmware em andamento. A versão {version} está sendo transferida e instalada.",
    backupInstallationInProgressTooltip:
      "Atualização de backup em andamento. A versão {version} está sendo transferida e instalada.",
    installationFailedCloseErrorFirmwareTooltip:
      "Feche a mensagem de erro acima para enviar o firmware novamente.",
    installationFailedCloseErrorBackupTooltip:
      "Feche a mensagem de erro acima para enviar o backup novamente.",
  },
};

export const otaUpdateSummaryDe = {
  [pageNameKey]: {
    latestText: "Neueste",
    versionText: "Version",
    sizeText: "Größe",
    digestText: "Prüfsumme",
    uploadTimeText: "Upload-Zeit",
    uploaderAltText: "Hochgeladen von",
    checkboxText: "Backup vor der Installation erstellen",
    installText: "Installieren",
    downloadText: "Herunterladen",
    failedMsg: "Installation konnte nicht gestartet werden",
    errorMsg: "Beim Starten der Installation ist ein Fehler aufgetreten.",
    noBackupsText: "Keine Backups verfügbar",
    noFirmwareText: "Keine Firmware verfügbar",
    noConfigurationText: "Keine Konfiguration verfügbar",
    backupInfoText: "Diese Karte zeigt das zuletzt erstellte Backup.",
    firmwareInfoText: "Diese Karte zeigt die zuletzt hochgeladene Firmware.",
    configurationInfoText:
      "Diese Karte zeigt die zuletzt hochgeladene Konfiguration.",
    pushFirmwareText: "Firmware übertragen",
    pushBackupText: "Backup übertragen",
    firmwareAlreadyInstalledTooltip:
      "Diese Firmware-Version {version} ist bereits auf der Maschine installiert.",
    backupAlreadyInstalledTooltip:
      "Diese Backup-Version {version} ist bereits auf der Maschine installiert.",
    firmwareInstallationInProgressTooltip:
      "Firmware-Update läuft. Version {version} wird derzeit übertragen und installiert.",
    backupInstallationInProgressTooltip:
      "Backup-Update läuft. Version {version} wird derzeit übertragen und installiert.",
    installationFailedCloseErrorFirmwareTooltip:
      "Schließen Sie die obige Fehlermeldung, um die Firmware erneut zu übertragen.",
    installationFailedCloseErrorBackupTooltip:
      "Schließen Sie die obige Fehlermeldung, um das Backup erneut zu übertragen.",
  },
};

export const otaUpdateSummaryZhHans = {
  [pageNameKey]: {
    latestText: "最新",
    versionText: "版本",
    sizeText: "大小",
    digestText: "摘要",
    uploadTimeText: "上传时间",
    uploaderAltText: "上传者",
    checkboxText: "安装前创建备份",
    installText: "安装",
    downloadText: "下载",
    failedMsg: "启动安装失败",
    errorMsg: "启动安装时发生错误。",
    noBackupsText: "没有可用的备份",
    noFirmwareText: "没有可用的固件",
    noConfigurationText: "没有可用的配置",
    backupInfoText: "此卡片显示最近创建的备份。",
    firmwareInfoText: "此卡片显示最近上传的固件。",
    configurationInfoText: "此卡片显示最近上传的配置。",
    pushFirmwareText: "推送固件",
    pushBackupText: "推送备份",
    firmwareAlreadyInstalledTooltip: "该固件版本 {version} 已安装在机器上。",
    backupAlreadyInstalledTooltip: "该备份版本 {version} 已安装在机器上。",
    firmwareInstallationInProgressTooltip:
      "固件更新进行中。版本 {version} 正在传输并安装。",
    backupInstallationInProgressTooltip:
      "备份更新进行中。版本 {version} 正在传输并安装。",
    installationFailedCloseErrorFirmwareTooltip:
      "请先关闭上方的错误消息，然后再次推送固件。",
    installationFailedCloseErrorBackupTooltip:
      "请先关闭上方的错误消息，然后再次推送备份。",
  },
};

export const otaUpdateSummaryIt = {
  [pageNameKey]: {
    latestText: "ULTIMA",
    versionText: "Versione",
    sizeText: "Dimensione",
    digestText: "Hash",
    uploadTimeText: "Tempo di caricamento",
    uploaderAltText: "Caricato da",
    checkboxText: "Crea backup prima dell'installazione",
    installText: "Installa",
    downloadText: "Scarica",
    failedMsg: "Installazione non avviata",
    errorMsg: "Si è verificato un errore durante l'installazione.",
    noBackupsText: "Nessun backup disponibile",
    noFirmwareText: "Nessun firmware disponibile",
    noConfigurationText: "Nessuna configurazione disponibile",
    backupInfoText: "La scheda mostra l'ultimo backup creato.",
    firmwareInfoText: "La scheda mostra l'ultimo firmware caricato.",
    configurationInfoText: "La scheda mostra l'ultima configurazione caricata.",
    pushFirmwareText: "Invia Firmware",
    pushBackupText: "Invia Backup",
    firmwareAlreadyInstalledTooltip:
      "Questa versione firmware {version} è già installata sulla macchina.",
    backupAlreadyInstalledTooltip:
      "Questa versione di backup {version} è già installata sulla macchina.",
    firmwareInstallationInProgressTooltip:
      "Aggiornamento firmware in corso. La versione {version} è attualmente in fase di trasferimento e installazione.",
    backupInstallationInProgressTooltip:
      "Aggiornamento backup in corso. La versione {version} è attualmente in fase di trasferimento e installazione.",
    installationFailedCloseErrorFirmwareTooltip:
      "Chiudi il messaggio di errore sopra per inviare di nuovo il firmware.",
    installationFailedCloseErrorBackupTooltip:
      "Chiudi il messaggio di errore sopra per inviare di nuovo il backup.",
  },
};

export const otaUpdateSummaryEs = {
  [pageNameKey]: {
    latestText: "ÚLTIMO",
    versionText: "Versión",
    sizeText: "Tamaño",
    digestText: "Hash",
    uploadTimeText: "Hora de carga",
    uploaderAltText: "Subido por",
    checkboxText: "Crear copia de seguridad antes de la instalación",
    installText: "Instalar",
    downloadText: "Descargar",
    failedMsg: "No se pudo iniciar la instalación",
    errorMsg: "Se produjo un error al iniciar la instalación.",
    noBackupsText: "No hay copias de seguridad disponibles",
    noFirmwareText: "No hay firmware disponible",
    noConfigurationText: "No hay configuración disponible",
    backupInfoText: "Esta tarjeta muestra la última copia de seguridad creada.",
    firmwareInfoText: "Esta tarjeta muestra el firmware subido más reciente.",
    configurationInfoText:
      "Esta tarjeta muestra la configuración cargada más reciente.",
    pushFirmwareText: "Enviar Firmware",
    pushBackupText: "Enviar Copia de Seguridad",
    firmwareAlreadyInstalledTooltip:
      "Esta versión de firmware {version} ya está instalada en la máquina.",
    backupAlreadyInstalledTooltip:
      "Esta versión de copia de seguridad {version} ya está instalada en la máquina.",
    firmwareInstallationInProgressTooltip:
      "Actualización de firmware en curso. La versión {version} se está transfiriendo e instalando actualmente.",
    backupInstallationInProgressTooltip:
      "Actualización de copia de seguridad en curso. La versión {version} se está transfiriendo e instalando actualmente.",
    installationFailedCloseErrorFirmwareTooltip:
      "Cierra el mensaje de error de arriba para volver a enviar el firmware.",
    installationFailedCloseErrorBackupTooltip:
      "Cierra el mensaje de error de arriba para volver a enviar la copia de seguridad.",
  },
};

export const otaUpdateSummaryNl = {
  [pageNameKey]: {
    backupInfoText: "De kaart toont u de laatst gemaakte back-up.",
    checkboxText: "Maak een back-up voor de installatie",
    configurationInfoText:
      "De kaart toont u de laatst geuploaded configuratie.",
    digestText: "Digest",
    downloadText: "Downloaden",
    errorMsg: "Er is een fout opgetreden bij het starten van de installatie.",
    failedMsg: "Installatie kon niet worden gestart",
    firmwareInfoText: "De kaart toont u de laatst geuploaded firmware.",
    installText: "Installeren",
    latestText: "NIEUWSTE",
    noBackupsText: "Geen back-ups beschikbaar",
    noConfigurationText: "Geen configuratie beschikbaar",
    noFirmwareText: "Geen firmware beschikbaar",
    sizeText: "Grootte",
    uploadTimeText: "Uploadtijd",
    uploaderAltText: "Uploader",
    versionText: "Versie",
    pushFirmwareText: "Firmware verzenden",
    pushBackupText: "Back-up verzenden",
    firmwareAlreadyInstalledTooltip:
      "Deze firmwareversie {version} is al op de machine geïnstalleerd.",
    backupAlreadyInstalledTooltip:
      "Deze back-upversie {version} is al op de machine geïnstalleerd.",
    firmwareInstallationInProgressTooltip:
      "Firmware-update wordt uitgevoerd. Versie {version} wordt momenteel overgezet en geïnstalleerd.",
    backupInstallationInProgressTooltip:
      "Back-upupdate wordt uitgevoerd. Versie {version} wordt momenteel overgezet en geïnstalleerd.",
    installationFailedCloseErrorFirmwareTooltip:
      "Sluit de foutmelding hierboven om de firmware opnieuw te verzenden.",
    installationFailedCloseErrorBackupTooltip:
      "Sluit de foutmelding hierboven om de back-up opnieuw te verzenden.",
  },
};

export const otaUpdateSummaryTr = {
  [pageNameKey]: {
    backupInfoText: "Kart size oluşturulan en son yedeği gösterir.",
    checkboxText: "Kurulumdan önce Yedekleme oluşturun",
    configurationInfoText: "Kart size en son yüklenen konfigürasyonu gösterir.",
    digestText: "Özet",
    downloadText: "İndirmek",
    errorMsg: "Kurulum başlatılırken bir şeyler ters gitti.",
    failedMsg: "Kurulum başlatılamadı",
    firmwareInfoText: "Kart size en son yüklenen ürün yazılımını gösterir.",
    installText: "Yükle",
    latestText: "EN SONUNCU",
    noBackupsText: "Yedekleme yok",
    noConfigurationText: "Yapılandırma mevcut değil",
    noFirmwareText: "Firmware yok",
    sizeText: "Boyut",
    uploadTimeText: "Yükleme Zamanı",
    uploaderAltText: "Yükleyici",
    versionText: "Sürüm",
    pushFirmwareText: "Firmware'i itin",
    pushBackupText: "Yedeklemeyi itin",
    firmwareAlreadyInstalledTooltip:
      "Bu donanım yazılımı sürümü {version} makineye zaten yüklenmiştir.",
    backupAlreadyInstalledTooltip:
      "Bu yedek sürüm {version} makinede zaten yüklü.",
    firmwareInstallationInProgressTooltip:
      "Firmware güncellemesi devam ediyor. Sürüm {version} şu anda aktarılıyor ve kuruluyor.",
    backupInstallationInProgressTooltip:
      "Yedekleme güncellemesi devam ediyor. Sürüm {version} şu anda aktarılıyor ve kuruluyor.",
    installationFailedCloseErrorFirmwareTooltip:
      "Firmware'i tekrar yüklemek için yukarıdaki hata mesajını kapatın.",
    installationFailedCloseErrorBackupTooltip:
      "Yedeklemeyi tekrar göndermek için yukarıdaki hata mesajını kapatın.",
  },
};
